import { render } from "./SupplierDetails.vue?vue&type=template&id=77056a80&scoped=true"
import script from "./SupplierDetails.vue?vue&type=script&lang=js"
export * from "./SupplierDetails.vue?vue&type=script&lang=js"

import "./SupplierDetails.vue?vue&type=style&index=0&id=77056a80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77056a80"]])

export default __exports__